module.exports = __webpack_public_path__ + "img/esmeralda-spa.dbd9a5f5.jpg";